<template>
	<div>
		<h1 :style="{textAlign: 'center'}">Szobapontozás kimutatás</h1>
		<v-row>
			<v-col cols="12" sm="5">
				<v-menu
					v-model="intervallumvalaszto.kezdomenu"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="intervallumvalaszto.kezdodatum"
							label="Intervallum eleje"
							prepend-inner-icon="fa-calendar-check"
							readonly
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="intervallumvalaszto.kezdodatum"
						no-title
						scrollable
						first-day-of-week="1"
						@input="intervallumvalaszto.kezdomenu=false, adatokfrissitese().then((ok) => {if(ok)diagramfrissitese()})"
					>
					</v-date-picker>
				</v-menu>
			</v-col>
      <v-col cols="12" sm="5">
				<v-menu
					v-model="intervallumvalaszto.befejezomenu"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="intervallumvalaszto.befejezodatum"
							label="Intervallum vége"
							prepend-inner-icon="fa-calendar-times"
							readonly
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="intervallumvalaszto.befejezodatum"
						no-title
						scrollable
						first-day-of-week="1"
						@input="intervallumvalaszto.befejezomenu=false, adatokfrissitese().then((ok) => {if(ok)diagramfrissitese()})"
					>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="2">
				<v-text-field
					v-model.number="alappont"
					prepend-inner-icon="fa-star"
					label="Alappont"
					@change="diagramfrissitese()"
					></v-text-field>
			</v-col>
		</v-row>
    <v-tabs
      v-model="diagramtipus"
      color="primary"
      icons-and-text
			@change="diagramfrissitese()"
    >
      <v-tab>Szobák szempontok és nevelők alapján<v-icon>fa-bed</v-icon></v-tab>
			<v-tab>Szempontok<v-icon>fa-broom</v-icon></v-tab>
			<v-tab>Nevelők összehasonlítása szempont és szoba alapján<v-icon>fa-chalkboard-teacher</v-icon></v-tab>
			<v-tab>Táblázatok<v-icon>fa-table</v-icon></v-tab>


    </v-tabs>
		<div v-if="diagramtipus==3">
			<h2 :style="{textAlign: 'center'}">Szobák szempontok alapján</h2>
			<v-data-table
				v-if="adatok.szobak"
				hide-default-footer
				disable-pagination
				:headers="[{
					text: 'Szoba',
					value: 'szoba',
					align: 'right',
					sortable: true,
					filterable: false,
					groupable: false
					},
					{
						text: 'Összes pont',
						value: 'pont',
						align: 'left',
						sortable: true,
						filterable: false,
						groupable: false
					}].concat(adatok.szobapontozasiszempontok.map(szpsz => {
						 return {
							text: szpsz.szempont+' ('+szpsz.pont+' pont)',
							value: 'szpsz'+szpsz.id,
							align: 'center',
							sortable: true,
							filterable: false,
							groupable: false
						}
					}))"
					:items="adatok.szobak.map(sz => {
						var pont = alappont;
						var szempontok = {};
						adatok.szobapontozas.filter(szp => szp.szobaid==sz.id).forEach(szp => {
							var szpsz = adatok.szobapontozasiszempontok.find(szpsz => szpsz.id==szp.pontozasiszempontid)
							pont+=szpsz.pont
							if(szempontok['szpsz'+szpsz.id]) szempontok['szpsz'+szpsz.id]+=szpsz.pont
							else szempontok['szpsz'+szpsz.id]=szpsz.pont;
						})
							return {
								szoba: sz.szobanev,
								pont: pont,
								...szempontok
							}
					})/*.concat({
						szoba: 'Összesen: ',
						pont:,
						szempontok: adatok.szobapontozasiszempontok.map(szpsz => {

							})
						})*/"
			>

			</v-data-table>
			<h2 :style="{textAlign: 'center'}">Szobák nevelők alapján</h2>

			<v-data-table
				v-if="adatok.szobak"
				:headers="[{
					text: 'Szoba',
					value: 'szoba',
					align: 'right',
					sortable: true,
					filterable: false,
					groupable: false
					}].concat(adatok.felhasznalok.filter(f => f.minosites<0).map(n => {
						 return {
							text: n.nev,
							value: 'n'+n.id,
							align: 'center',
							sortable: true,
							filterable: false,
							groupable: false
						}
					}))"
					:items="adatok.szobak.map(sz => {
						var nevelok = {};
						adatok.szobapontozas.filter(szp => szp.szobaid==sz.id).forEach(szp => {
							var szpsz = adatok.szobapontozasiszempontok.find(szpsz => szpsz.id==szp.pontozasiszempontid)
							if(nevelok['n'+szp.neveloid]) nevelok['n'+szp.neveloid]+=szpsz.pont
							else nevelok['n'+szp.neveloid]=szpsz.pont;
						})
							return {
								szoba: sz.szobanev,
								...nevelok
							}
					})"
			>

			</v-data-table>
		</div>
		<canvas ref="diagram1"></canvas>
		<canvas ref="diagram2"></canvas>
		<canvas ref="diagram3"></canvas>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	var diagramok = [];

	export default {
		data: function(){
			return {
				alappont: 400,
        diagramtipus: 0,
				intervallumvalaszto: {
					kezdodatum: ((date, months) => {
						var d = date.getDate();
		        date.setMonth(date.getMonth() + +months);
		        if (date.getDate() != d) {
		          date.setDate(0);
		        }
		        return date;
					})(new Date(),-1).toISOString().substring(0,10),
          befejezodatum: (new Date()).toISOString().substring(0,10),
					kezdomenu: false,
          befejezomenu: false
				},
        snackbar: {
          megnyit: false,
          szoveg: ""
        },

        adatok: {}
      }
		},
		computed: {
		},
		watch: {

		},
		methods: {
			diagramfrissitese: function() {
				var diagramadatok = [{}];
				switch(this.diagramtipus) {
					case 0: //Szobák összesítése
						diagramadatok[0] = { //Pontozási szempontok szerint
							type: 'bar',
							data: {
									labels: this.adatok.szobak.map(sz => sz.szobanev),
									datasets: this.adatok.szobapontozasiszempontok.map(szpsz => {
										return {
											label: szpsz.szempont+" ("+szpsz.pont+" pont)",
											data: this.adatok.szobak.map(sz => this.adatok.szobapontozas.filter(szp => szp.pontozasiszempontid==szpsz.id&&szp.szobaid==sz.id).length*szpsz.pont),
											backgroundColor: this.szingeneralas()
										};

									}),
							},
							options: {
									plugins: {
										datalabels: {
											display: false
										},
									},
									scales: {
										xAxes: [{
												stacked: true
										}],
										yAxes: [{
												stacked: true,
												beginAtZero: true,
										}]
									},
									title: {
										display: true,
										text: "Szobák pontjai összesítve pontozási szempontok szerint: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
										fontSize: 20,
										fontColor: 'blue'
									}
								}
							}
							diagramadatok[1] = {
								type: 'bar',
								data: {
										labels: this.adatok.szobak.map(sz => sz.szobanev),
										datasets: this.adatok.felhasznalok.filter(f => f.minosites<0).map(n => {
											return {
												label: n.nev,
												data: this.adatok.szobak.map(sz => {
													var pont=0;
													this.adatok.szobapontozas.filter(szp => szp.szobaid==sz.id&&szp.neveloid==n.id).forEach(szp => {
														pont+=this.adatok.szobapontozasiszempontok.find(szpsz => szpsz.id==szp.pontozasiszempontid).pont
													})
													return pont;
												}),
												backgroundColor: this.szingeneralas()
											}
										})
								},
								options: {
										plugins: {
											datalabels: {

												display: false
											},
										},

										title: {
											display: true,
											text: "Szobák pontjai összesítve nevelők szerint: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
											fontSize: 20,
											fontColor: 'blue'
										},
										scales: {
											xAxes: [{
													stacked: true,
											}],
											yAxes: [{
													stacked: true,
													beginAtZero: true,
											}]
										}
									}
							}
							var szinek = this.adatok.szobak.map(sz => this.szingeneralas());
							diagramadatok[2] = {
								type: 'bar',
								data: {
										labels: this.adatok.szobak.map(sz => sz.szobanev),
										datasets: [{
			                  label: 'Pont',
			                  data: this.adatok.szobak.map(sz => {
													var ossz=this.alappont;
													this.adatok.szobapontozas.filter(szp => szp.szobaid==sz.id).forEach(szp => {
														ossz+=this.adatok.szobapontozasiszempontok.find(szpsz => szpsz.id==szp.pontozasiszempontid).pont
													})
													return ossz
												}),
			                  borderWidth: 1,
			                  backgroundColor: szinek,
			                  borderColor: szinek
			              }],
								},
								options: {
										plugins: {
											datalabels: {
												display: true,
												backgroundColor: "yellow"
											},
										},

										legend: {
			                display:false
			              },
										title: {
											display: true,
											text: "Szobák pontjai összesítve: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
											fontSize: 20,
											fontColor: 'blue'
										},
										scales: {
											yAxes: [{
												beginAtZero: true
											}],
											xAxes: [{
												beginAtZero: true
											}]
										}
									}
							}
					break;
					case 1: //szempontok
						diagramadatok[0] = { //Nevelők
							type: 'bar',
							data: {
									labels: this.adatok.szobapontozasiszempontok.map(sz => sz.szempont+" ("+sz.pont+" pont)"),
									datasets: this.adatok.felhasznalok.filter(f => f.minosites<0).map(n => {
										return {
											label: n.nev,
											data:this.adatok.szobapontozasiszempontok.map(szpsz => this.adatok.szobapontozas.filter(szp => szp.pontozasiszempontid==szpsz.id&&szp.neveloid==n.id).length*szpsz.pont),
											backgroundColor: this.szingeneralas()
										};

									}),
							},
							options: {
									plugins: {
										datalabels: {
											display: false
										},
									},
									scales: {
										xAxes: [{
												stacked: true
										}],
										yAxes: [{
												stacked: true,
												beginAtZero: true,
										}]
									},
									title: {
										display: true,
										text: "Szempontok nevelők szerinti összehasonlítása: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
										fontSize: 20,
										fontColor: 'blue'
									}
								}
							}
							diagramadatok[1] = { //Szobák
								type: 'bar',
								data: {
										labels: this.adatok.szobapontozasiszempontok.map(sz => sz.szempont+" ("+sz.pont+" pont)"),
										datasets: this.adatok.szobak.map(sz => {
											return {
												label: sz.szobanev,
												data:this.adatok.szobapontozasiszempontok.map(szpsz => this.adatok.szobapontozas.filter(szp => szp.pontozasiszempontid==szpsz.id&&szp.szobaid==sz.id).length*szpsz.pont),
												backgroundColor: this.szingeneralas()
											};

										}),
								},
								options: {
										plugins: {
											datalabels: {
												display: false
											},
										},
										scales: {
											xAxes: [{
													stacked: true
											}],
											yAxes: [{
													stacked: true,
													beginAtZero: true,
											}]
										},
										title: {
											display: true,
											text: "Szempontok szobák szerinti összehasonlítása: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
											fontSize: 20,
											fontColor: 'blue'
										}
									}
								}
								diagramadatok[2] = { //Összesített
									type: 'bar',
									data: {
											labels: this.adatok.szobapontozasiszempontok.map(sz => sz.szempont+" ("+sz.pont+" pont)"),
											datasets: [
												{
													label: "Pont",
													data: this.adatok.szobapontozasiszempontok.map(szpsz => this.adatok.szobapontozas.filter(szp => szp.pontozasiszempontid==szpsz.id).length*szpsz.pont),
													backgroundColor: this.szingeneralas()
												}
											],
									},
									options: {
											plugins: {
												datalabels: {
													backgroundColor: "yellow"
												},
											},
											scales: {
												xAxes: [{
														stacked: true
												}],
												yAxes: [{
														stacked: true,
														beginAtZero: true,
												}]
											},
											title: {
												display: true,
												text: "Szempontok összesen: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
												fontSize: 20,
												fontColor: 'blue'
											}
										}
									}
					break;
					case 2: //Nevelők
					diagramadatok[0] = { //Szempontok
						type: 'bar',
						data: {
								labels: this.adatok.felhasznalok.filter(f => f.minosites<0).map(n => n.nev),
								datasets: this.adatok.szobapontozasiszempontok.map(szpsz => {
									return {
										label: szpsz.szempont+" ("+szpsz.pont+" pont)",
										data:this.adatok.felhasznalok.filter(f => f.minosites<0).map(n => this.adatok.szobapontozas.filter(szp => szp.pontozasiszempontid==szpsz.id&&szp.neveloid==n.id).length*szpsz.pont),
										backgroundColor: this.szingeneralas()
									};

								}),
						},
						options: {
								plugins: {
									datalabels: {
										display: false
									},
								},
								scales: {
									xAxes: [{
											stacked: true
									}],
									yAxes: [{
											stacked: true,
											beginAtZero: true,
									}]
								},
								title: {
									display: true,
									text: "Nevelők szempontok szerinti összehasonlítása: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
									fontSize: 20,
									fontColor: 'blue'
								}
							}
						}
						diagramadatok[1] = { //Szobák
							type: 'bar',
							data: {
									labels: this.adatok.felhasznalok.filter(f => f.minosites<0).map(n => n.nev),
									datasets: this.adatok.szobak.map(sz => {
										return {
											label: sz.szobanev,
											data:this.adatok.felhasznalok.filter(f => f.minosites<0).map(n => {
												var pont=0;
												this.adatok.szobapontozas.filter(szp => szp.szobaid==sz.id&&szp.neveloid==n.id).forEach(szp => {
													pont+=this.adatok.szobapontozasiszempontok.find(szpsz => szpsz.id==szp.pontozasiszempontid).pont;
												})
												return pont
											}),
											backgroundColor: this.szingeneralas()
										};

									}),
							},
							options: {
									plugins: {
										datalabels: {
											display: false
										},
									},
									scales: {
										xAxes: [{
												stacked: true
										}],
										yAxes: [{
												stacked: true,
												beginAtZero: true,
										}]
									},
									title: {
										display: true,
										text: "Nevelők szobák szerinti összehasonlítása: "+this.intervallumvalaszto.kezdodatum+" - "+this.intervallumvalaszto.befejezodatum,
										fontSize: 20,
										fontColor: 'blue'
									}
								}
							}
					break;
				}
				for(var i =0;i<3;i++) {
					if(diagramok[i]) diagramok[i].destroy();
					if(diagramadatok[i])
						diagramok[i]=new this.Chart(this.$refs['diagram'+(i+1)],diagramadatok[i])
				}

			},
			szingeneralas: function() {
	      var r, g, b;
	      do{
	        r = Math.floor(Math.random() * 255);
	        g = Math.floor(Math.random() * 255);
	        b = Math.floor(Math.random() * 255);
	      } while(Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))<155&&Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))>100)
	     return "rgb(" + r + "," + g + "," + b + ")";
	    },
	    diagrammentese: function() {
	      if(diagram) require("downloadjs")(diagram.toBase64Image(), "diagram.png", "image/png");
	    },
			adatokfrissitese: function() {
				return new Promise((ok,nemok) =>{
					this.axios.get(this.$store.state.backendeleres+"szobapontozas/"+this.intervallumvalaszto.kezdodatum+"/"+this.intervallumvalaszto.befejezodatum).then((response) => {
						if(response.data.ok){
		          this.adatok=response.data.adatok;
							ok(true);
						}
		        if(response.data.bejelentkezve== false) this.kijelentkezes();
					})
				})

			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hettetszolegesnapja: function(hetfo, nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(hetfo))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			},
			osszeg: function(szoba, nap) {
				var osszeg =this.adatok.alapszobapont;
				this.adatok.szobapontozas.filter(p => p.nap==nap&&p.szobaid==szoba).forEach(p => {
					osszeg+=this.adatok.szobapontozasiszempontok.find(szp => szp.id==p.pontozasiszempontid).pont
				})
				return osszeg;
			}

		},
		mounted(){
			this.adatokfrissitese().then((ok) => {
				if(ok) this.diagramfrissitese();
			});
		}
	}
</script>
